import { ERequestForDeliveryAssigner } from '../../../../Domain/Enum/ERequestForDeliveryAssigner';
import { EEntityType } from '../../../../Domain/Enum/EEntityType';
import { VolmaContainer } from '../../../../Infrastructure/InversifyInject';
import { Types } from '../../../../Infrastructure/Types';
import { VolmaModalActions } from '../../../VolmaModal/VolmaModalActions';
import { DeliveryTableActions } from '../Table/DeliveryTableActions';
import { IVolmaTableAction } from '../../../Table/VolmaTable/IVolmaTableProps';
import { DeliveryManualAssignDTO } from '../../../../Domain/DTO/DeliveryManualAssignDTO';
import i18next from '../../../i18n';
import { DeliveryUpdateAssignTypeDTO } from '../../../../Domain/DTO/DeliveryUpdateAssignTypeDTO';
import { DeliveryTableDTO } from '../../../../Domain/DTO/DeliveryTableDTO';
import { VolmaTableAction } from '../../../Table/VolmaTable/VolmaTableAction';
import { EDeliveryState } from '../../../../Domain/Enum/EDeliveryState';
import { DeliveryStateDTO } from '../../../../Domain/DTO/DeliveryStateDTO';
import PropertyHelper from '../../../../Infrastructure/Services/PropertyHelper';
import { Assignation } from '../Status/Assignation';
import { TableDataDTO } from '../../../../Domain/TableDataDTO';

export class MassAuctionAction<THelper> extends VolmaTableAction<THelper>{
    private _modalActions: VolmaModalActions;
    private _deliveryTableActions: DeliveryTableActions;

    public Title: string = "delivery:MassAuction";
    
    public IsAvailable(selectedIds: Array<string>, data: Array<DeliveryTableDTO>){
        if (this._authService.IsShipper()) {
            if (!PropertyHelper.IsArray(selectedIds) || selectedIds.length < 1)
                return false;
            for (let selectedId of selectedIds){
                let itm = data.find(x => x.Id === selectedId);
                if (itm === undefined || !(itm.State === EDeliveryState.Assignation && itm.AssignType === ERequestForDeliveryAssigner.Manual))
                    return false;
            }
            return true;
        }
        return false;
    }
    
    public OnActivate(name: string, entity: EEntityType, selectedIds: Array<string>, data: Array<DeliveryTableDTO>, dispatch: any, reloadData: () => void) {
        let identifiers = new Array<string>();
        for (let selectedId of selectedIds) {
            let itm = data.find(x => x.Id === selectedId);
            if (itm !== undefined)
                identifiers.push(itm.Identifier);
        }
        let text = i18next.t("delivery:StartAuctionDeliveries", { count: selectedIds.length, identifier: identifiers.join(', ') } as any)
        dispatch(this._modalActions.OpenConfirmationModal(text, () => {

            let tableDataDTO = new TableDataDTO<DeliveryStateDTO>();
            tableDataDTO.Items = new Array<DeliveryStateDTO>();
            tableDataDTO.Count = 0;
            for (let selectedId of selectedIds) {
                let stateDTO = new DeliveryStateDTO();
                stateDTO.DeliveryId = selectedId;
                stateDTO.DeliveryState = EDeliveryState.New;
                stateDTO.Assigner = ERequestForDeliveryAssigner.Bidding;
                tableDataDTO.Items.push(stateDTO);
                tableDataDTO.Count++;
            }

            dispatch(this._deliveryTableActions.DeliveryAddStates(tableDataDTO, i18next.t("common:Loading"), reloadData));
        }))
    }

    constructor(){
        super();
        this._modalActions         = VolmaContainer.get<VolmaModalActions>(Types.VolmaModalActions);
        this._deliveryTableActions = VolmaContainer.get<DeliveryTableActions>(Types.DeliveryTableActions);
    }
}